
import { useSearchContext } from "Context/contexts/searchContext";
import React from "react";

const HighlightedText = ({ text }: { text: string;}) => {
  const { searchTerm, selectedItem } = useSearchContext();

  // If this widget is the selected one → mark the whole text orange
  if (text === selectedItem) {
    return (
      <mark
        style={{
          backgroundColor: "orange",
          padding: "0 2px",
          borderRadius: "3px",
        }}
      >
        {text}
      </mark>
    );
  }

  if (!searchTerm) return <>{text}</>;

  // Otherwise highlight only matching substring in yellow
  const regex = new RegExp(`(${searchTerm})`, "gi");
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, i) =>
        regex.test(part) ? (
          <mark
            key={`${part} - ${i}`}
            style={{
              backgroundColor: "yellow",
              padding: "0 2px",
              borderRadius: "3px",
            }}
          >
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  );
};

export default HighlightedText;
